/* eslint-disable react/require-default-props */
import React, { useRef, useEffect, useCallback } from 'react';
import { useAIInput } from '../../AIInputContext';
import './CleanTextInputStyles.scss';
/**
 * CleanTextInput Component
 * A minimal auto-resizing textarea with no border or background
 * @version 1.0.0
 * @since 2026-02-17
 */
export function CleanTextInput({ placeholder, onSubmit, autoFocus, textareaRef: externalRef }) {
    const { text, setText } = useAIInput();
    const internalRef = useRef(null);
    const textareaRef = externalRef || internalRef;
    const setRef = useCallback((el) => {
        textareaRef.current = el;
    }, [textareaRef]);
    // Auto-resize textarea based on content
    useEffect(() => {
        const el = textareaRef.current;
        if (el) {
            el.style.height = 'auto';
            el.style.height = `${el.scrollHeight}px`;
        }
    }, [text]);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey && onSubmit) {
            e.preventDefault();
            onSubmit();
        }
    };
    return (React.createElement("textarea", { ref: setRef, className: "qmb-ui-ai-input__textarea", placeholder: placeholder, value: text, onChange: (e) => setText(e.target.value), onKeyDown: handleKeyDown, rows: 1, "aria-label": placeholder, 
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: autoFocus }));
}
